/**
 * Zárt vásárlói csoportok API — vásárlói (csatlakozás, csoport-oldal, üdvözlő sáv) és admin
 * (csoportok, tagok, meghívó kód). Módosítani csak tulajdonos (superuser) tud; a backend 403-mal véd.
 */
import api from './api';
import {
  AdminCustomerGroup, AdminCustomerGroupDetail, AdminGroupInput, AdminGroupMember, CategoryRestriction,
  GroupPagePayload, JoinGroupResponse,
} from '../types/customerGroups';

const enc = encodeURIComponent;

export const joinGroup = async (code: string): Promise<JoinGroupResponse> =>
  (await api.post<JoinGroupResponse>('/customer-groups/join/', { code })).data;

export const getGroupPage = async (slug: string): Promise<GroupPagePayload> =>
  (await api.get<GroupPagePayload>(`/customer-groups/${enc(slug)}/`)).data;

export const dismissGroupWelcome = async (slug: string): Promise<void> => {
  await api.post(`/customer-groups/${enc(slug)}/welcome-dismiss/`);
};

export const listAdminGroups = async (): Promise<AdminCustomerGroup[]> =>
  (await api.get<AdminCustomerGroup[]>('/admin/customer-groups/')).data;

export const getAdminGroup = async (id: number): Promise<AdminCustomerGroupDetail> =>
  (await api.get<AdminCustomerGroupDetail>(`/admin/customer-groups/${id}/`)).data;

export const createAdminGroup = async (input: AdminGroupInput): Promise<AdminCustomerGroupDetail> =>
  (await api.post<AdminCustomerGroupDetail>('/admin/customer-groups/', input)).data;

export const updateAdminGroup = async (
  id: number, input: Partial<AdminGroupInput>,
): Promise<AdminCustomerGroupDetail> =>
  (await api.patch<AdminCustomerGroupDetail>(`/admin/customer-groups/${id}/`, input)).data;

export const deleteAdminGroup = async (id: number): Promise<void> => {
  await api.delete(`/admin/customer-groups/${id}/`);
};

export const regenerateInviteCode = async (id: number): Promise<AdminCustomerGroupDetail> =>
  (await api.post<AdminCustomerGroupDetail>(`/admin/customer-groups/${id}/invite/regenerate/`)).data;

export const listGroupMembers = async (id: number, search = ''): Promise<AdminGroupMember[]> =>
  (await api.get<AdminGroupMember[]>(`/admin/customer-groups/${id}/members/`, {
    params: search ? { search } : {},
  })).data;

export const addGroupMember = async (id: number, userId: number): Promise<AdminGroupMember[]> =>
  (await api.post<AdminGroupMember[]>(`/admin/customer-groups/${id}/members/`, { user_id: userId })).data;

export const removeGroupMember = async (id: number, userId: number): Promise<void> => {
  await api.delete(`/admin/customer-groups/${id}/members/${userId}/`);
};

export const getCategoryRestriction = async (categoryId: number): Promise<CategoryRestriction> =>
  (await api.get<CategoryRestriction>(`/admin/categories/${categoryId}/restriction/`)).data;

/** „Nyilvánossá tétel” — csak tulajdonos, kifejezett megerősítéssel (a szerver naplózza). */
export const makeCategoryPublic = async (categoryId: number): Promise<CategoryRestriction> =>
  (await api.post<CategoryRestriction>(`/admin/categories/${categoryId}/make-public/`, { confirm: true })).data;
